
export const libPrefix = '@pcs';
